import { render, staticRenderFns } from "./product4.vue?vue&type=template&id=3cd8160f&scoped=true"
import script from "./product4.vue?vue&type=script&lang=js"
export * from "./product4.vue?vue&type=script&lang=js"
import style0 from "./product4.vue?vue&type=style&index=0&id=3cd8160f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd8160f",
  null
  
)

export default component.exports